<template>
    <div>
        <h3 v-if="title">{{title}}</h3>
        <div class="row">
            <div class="form-group col-lg-4 col-xl-2 col-md-6">
                <label class="font-weight-bold">{{$t('person.firstName') }}</label>
                <input type="text" class="form-control" readonly v-model="person.firstName">
                <!--<div class="form-control">{{person.firstName}}</div>-->
            </div>
            <div class="form-group col-lg-4 col-xl-2 col-md-6">
                <label class="font-weight-bold">{{ $t('person.middleName') }}</label>
                <input type="text" class="form-control" readonly v-model="person.middleName">
                <!--<div class="form-control">{{person.middleName}}</div>-->
            </div>
            <div class="form-group col-lg-4 col-xl-2 col-md-6">
                <label class="font-weight-bold">{{ $t('person.lastName') }}</label>
                <input type="text" class="form-control" readonly v-model="person.lastName">
                <!--<div class="form-control">{{person.lastName}}</div>-->
            </div>
            <div class="form-group col-lg-4 col-xl-2 col-md-6">
                <label class="font-weight-bold">{{ $t('email') }}</label>
                <input type="text" class="form-control" readonly v-model="person.email">
                <!--<div class="form-control">{{person.email}}</div>-->
            </div>
            <div class="form-group col-lg-4 col-xl-2 col-md-6">
                <label class="font-weight-bold">{{ $t('person.phone') }}</label>
                <input type="text" class="form-control" readonly v-model="person.phone">
                <!--<div class="form-control">{{person.phone}}</div>-->
            </div>
            <div class="form-group col-lg-4 col-xl-2 col-md-6">
                <label class="font-weight-bold">{{ $t('person.mobilePhone') }}</label>
                <input type="text" class="form-control" readonly v-model="person.mobilePhone">
                <!--<div class="form-control">{{person.mobilePhone}}</div>-->
            </div>
        </div>
    </div>
</template>

<script>
    import { PersonDetails } from '../../models/models';

    export default {
        inject: ['$validator'],
        props: {
            person: [PersonDetails, Object],
            title: String
        }
    }
</script>

<style scoped>
    input[readonly] {
        background-color: whitesmoke;
    }

    textarea[readonly] {
        background-color: whitesmoke;
    }
</style>
